import cn from 'classnames';
import styles from './index.module.scss';

export const Skeleton = ({ className }: { className?: string }) => {
  return <div className={cn(styles.shimmer, className)} />;
};
